module.exports = __webpack_public_path__ + "img/orange_002.94ae439c.png";